<template>
  <div class="recommendPage">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="item in list" :key="item.id">
        <img :src="item.path" :alt="item.title" :title="item.title" srcset="" @click="toArticleDetail(item.id)">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      swiperOption: {
        loop: true,
        loopAdditionalSlides: 3,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        }
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false);
  },
  methods: {
    toArticleDetail(id) {
      let {href} = this.$router.resolve({path: `/a-detail?id=${id}`})
      window.open(href, '_blank')
    },
  }
}
</script>
<style scoped lang="less">
.recommendPage .swiper-container{
  position: relative;
  width: 100%;
  height: 300px;
}
.recommendPage .swiper-container .swiper-slide{
  width: 100%;
  line-height: 200px;
  color: #000;
  font-size: 16px;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    // cursor: pointer;
  }
}
</style>
